import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { StockReturnRequestApprovalProvider } from '../unhcr/stockReturnRequestApproval/ContextAPI';
import Index from '../unhcr/stockReturnRequestApproval/Index';
import PermissionDenied from './PermissionDenied';

export default function StockReturnRequestApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['stock-return-request-approval']) return <PermissionDenied />;

    return (
        <StockReturnRequestApprovalProvider>
            <Index />
        </StockReturnRequestApprovalProvider>
    );
}
